import { schoolAdminRoutes } from './admin-routes';
import { studentRoutes } from './student-routes';
import { teacherRoutes } from './teacher-routes';

export const routes = {
  school_admin: schoolAdminRoutes,
  teacher: teacherRoutes,
  student: studentRoutes,
} as const;
